let initialState = {
  rightBasketModal: false,
  basketList: localStorage.getItem('basketList') ? JSON.parse(localStorage.getItem('basketList')) : [],
}

export default function BasketReducer (state = initialState, action) {
  if (action.type === 'setRightBasketModal') {
    return Object.assign({}, state,
      { rightBasketModal: action.payload.rightBasketModal })
  } else if (action.type === 'setBasketList') {
    return Object.assign({}, state,
      { basketList: action.payload.basketList })
  } else {
    return state
  }
}
